import React from "react";
import Dropdown from "./Helper/dropdown";
import noteStore from "../../noteStore";

function Header({ selectedOption, setSelectedOption, activeUsers }) {
    const options = [5, 10, 20, 50, 100];
    const { setNotePageOne } = noteStore();

    const handleDropdownChange = (event) => {
        const selectedValue = parseInt(event.target.value, 10);
        setSelectedOption(selectedValue);
        setNotePageOne();
    };

    return (
        <header className="notes-app-header">
            <div className="notespage-header">
                <h1 className="notes-app-header__title">MERN Notes</h1>
                <div className="notes-per-page-input">
                    <Dropdown
                        selectedValue={selectedOption}
                        options={options}
                        onChange={handleDropdownChange}
                    />
                </div>
            </div>
        </header>
    );
}

export default Header;
